import { FONT_FAMILY } from '@/styles'
import { SxProps } from '@mui/material'

interface BannerChipsStyles {
  list: SxProps
  listShow: SxProps
  listItem: SxProps
  chip: SxProps
  chipText: SxProps
  arrow: SxProps
}

export const bannerChipsStyles: BannerChipsStyles = {
  list: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: { xs: 1.5, md: 3 },
    listStyle: 'none',
    p: 0,
    m: 0,
    pt: { xs: 1, md: 1 },
    opacity: 0,
    transition: 'opacity 0.3s ease',
    /**
     * below styles makes chips appear in one line second line will be hidden
     */
    height: 45,
    overflow: 'hidden',
  },
  listShow: {
    opacity: 1,
  },
  listItem: {
    p: 0,
    '.link': {
      textDecoration: 'none',
    },
  },
  chip: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: 1, md: 1.5 },
    px: { xs: 1.5, md: 2 },
    py: { xs: 0.5, md: 0.5 },
    border: '1px solid ',
    borderColor: 'text.primaryWarmIvory',
    borderRadius: 25,
    color: 'text.primaryWarmIvory',
    transition: '0.3s',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      borderColor: 'rgba(255, 255, 255, 0.75)',
    },
  },
  chipText: {
    typography: { xs: 'textXs', md: 'textSm' },
    fontFamily: FONT_FAMILY.SECONDARY,
    pt: 0.25,
  },
  arrow: {
    width: { xs: 10, md: 20 },
    pt: { xs: 0.125, md: 0.25 },
  },
}
